<template>
  <div class="login-page" :class="{ loginOnly: !isAtHome }">
    <div class="login-wrap">
      <div class="input-area custom-login-input">
        <div class="title">
          <img v-if="!isLogin" :src="title" alt />
          <img v-if="isLogin" :src="title02" alt />
        </div>
        <div v-if="!isLogin" class="login-out">
          <el-input
            ref="account"
            @blur="accountBlur"
            @keyup.enter.native="loginAction"
            placeholder="账号"
            class="input-item"
            size="small"
            v-model="username"
          >
            <i
              slot="prefix"
              style="line-height: 2"
              class="iconfont-jinsha icon-jinshause"
            ></i>
          </el-input>
          <el-input
            @keyup.enter.native="loginAction"
            placeholder="密码"
            type="password"
            class="input-item"
            size="small"
            v-model="password"
          >
            <i
              slot="prefix"
              style="line-height: 2"
              class="iconfont-jinsha icon-jinshamima"
            ></i>
          </el-input>
          <el-input
            v-if="!loginCaptchaId || loginCaptchaId.length <= 5"
            @keyup.enter.native="loginAction"
            size="small"
            class="input-item"
            placeholder="验证码"
            v-model="vrifyCode"
          >
            <i
              slot="prefix"
              style="line-height: 2"
              class="iconfont-jinsha icon-jinshayanzhengma"
            ></i>
            <i v-if="securityCodeSrc" slot="suffix">
              <img
                @click="getVifyCode"
                style="
                  cursor: pointer;
                  height: 32px;
                  position: relative;
                  left: 5px;
                "
                :src="securityCodeSrc"
                alt
              />
            </i>
          </el-input>
          <div ref="captcha" class="captcha"></div>
          <div class="btn-wrap">
            <el-button
              @click.native="loginAction"
              class="left"
              size="small"
              type="primary"
              >立即登入</el-button
            >
            <router-link to="/register">
              <el-button class="right" size="small" type="primary"
                >免费开户</el-button
              >
            </router-link>
          </div>
          <span @click="showForgetPasswordDialog" class="forgetPassword"
            >忘记密码？</span
          >
        </div>
        <div class="login-in" v-if="isLogin">
          <p class="userAccount">
            账号:
            <router-link to="/mine" class="info">{{ userAccount }}</router-link>
            <router-link to="/mine/inEmail" class="info inemail">
              <img :src="msg" height="16" />
              <el-badge
                :value="inEmailNoRead"
                :max="99"
                v-show="inEmailNoRead > 0"
              />
            </router-link>
          </p>
          <p class="balance">
            账户余额:
            <router-link to="/mine/capital/account" class="info"
              >￥{{ accountBalance }}</router-link
            >
            <span
              @click="refresh()"
              style="cursor: pointer; font-size: 16px"
              :class="{ rotate: isRotate }"
              class="el-icon-refresh"
            ></span>
          </p>
          <ul class="mine-nav">
            <li
              v-for="(item, index) in mineNav"
              :class="{ line: index === 0 || index === 3 }"
              :key="item.name"
            >
              <router-link v-if="item.url" :to="item.url">{{
                item.name
              }}</router-link>
              <a v-if="item.src" :href="item.src" target="_blank">{{
                item.name
              }}</a>
            </li>
          </ul>
          <p class="balance">
            余额宝:
            <router-link to="/mine/yuebao" class="info">
              <span>本金：</span>
              <span>￥{{ totalCapital }}</span>
              <span>利息：</span>
              <span>￥{{ totalRate }}</span>
            </router-link>
          </p>
          <el-button @click.native="loginOut" size="small" type="primary"
            >退出账户</el-button
          >
        </div>
      </div>
      <div v-if="isAtHome" class="notice">
        <marquee-new :is-vertical="true"></marquee-new>
      </div>
    </div>
    <forget-password
      @forgetPasswordDialog="forgetPasswordDialog"
      :showForgetPassword="showForgetPassword"
    ></forget-password>
  </div>
</template>

<script>
/*eslint-disable*/
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { common, commonApi } from "@/common/index";
import { mapActions, mapState, mapMutations } from "vuex";
import ForgetPassword from "../../../components/base/forgetPassword/forgetPassword";
import MarqueeNew from "../../../components/base/marqueeN";

export default {
  name: "login-box",
  props: {
    isAtHome: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    MarqueeNew,
    swiper,
    swiperSlide,
    ForgetPassword,
  },
  data() {
    return {
      msg: require("./m_icon.png"),
      title: require("./title.png"),
      title02: require("./title02.png"),
      mineNav: [
        { name: "投注记录", url: "/mine/betList", src: "" },
        // {name: '我要存款', url: '/mine/capital/deposit', src: window.location.protocol+'//'+window.location.host+'/#/mine/capital/deposit'},
        { name: "我要存款", url: "/mine/capital/deposit", src: "" },
        { name: "修改登入密码", url: "/mine/safety", src: "" },
        { name: "交易记录", url: "/mine/billDetail", src: "" },
        { name: "我要提款", url: "/mine/capital/withdrawal", src: "" },
        { name: "修改取款密码", url: "/mine/safety", src: "" },
      ],
      // 刷新
      isRotate: false,
      // 忘记密码
      showForgetPassword: false,
      username: "",
      password: "",
      vrifyCode: "",
      timestamp: "",
      securityCodeSrc: "",
      isReady: true,
      validate: "",
    };
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      userAccount: (state) => state.userInfo.userInfo.userAccount,
      accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
      is_login_focus: (state) => state.is_login_focus,
      inEmailNoRead: (state) => state.inEmailNoRead,
      totalCapital: (state) => state.userInfo.rateInfo.totalCapital,
      totalRate: (state) => state.userInfo.rateInfo.totalRate,
      loginCaptchaId: (state) => state.linkList.loginCaptchaId,
    }),
  },
  watch: {
    is_login_focus() {
      if (this.is_login_focus) {
        this.$nextTick(() => {
          this.$refs.account.focus();
        });
      }
    },
    loginCaptchaId: {
      handler(val) {
        if (!!val && val.length > 5) {
          let protocol = window.location.protocol;
          var url =
            protocol +
            "//cstaticdun.126.net/load.min.js" +
            "?t=" +
            this.getTimestamp(1 * 60 * 1000); // 时长1分钟，建议时长分钟级别
          this.loadScript(url, () => {
            var options = {
              element: this.$refs.captcha,
              captchaId: this.loginCaptchaId,
              // mode: 'bind',
              onVerify: (err, data) => {
                if (data.validate) {
                  this.validate = data.validate;
                  this.validateCode = true;
                }
              },
              onClose: () => {
                this.instance.refresh();
                this.isReady = false;
              },
            };
            // 若load钩子使用箭头函数，则不需要self变量
            var self = this;
            initNECaptcha(
              options,
              function (instance) {
                self.instance = instance;
              },
              function (err) {
                initNECaptcha(options, function (instance) {
                  self.instance = instance;
                });
              }
            );
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["setShowRepwd"]),
    ...mapActions(["checkLogin", "IS_LOGIN_FOCUS", "getFirstInfo"]),
    // 账号失去焦点
    accountBlur() {
      this.IS_LOGIN_FOCUS(false);
    },
    //忘记密码
    showForgetPasswordDialog() {
      this.showForgetPassword = true;
    },
    forgetPasswordDialog() {
      this.showForgetPassword = false;
    },
    loginAction() {
      if (!!this.loginCaptchaId && this.loginCaptchaId.length > 5) {
        var params = {
          appType: "PC",
          username: this.username,
          password: this.password,
          node: 'login',
          timestamp: this.timestamp,
          loginType: "captcha",
          validate: this.validate,
        };
      } else {
        var params = {
          appType: "PC",
          username: this.username,
          node: 'login',
          password: this.password,
          vrifyCode: this.vrifyCode,
          timestamp: this.timestamp,
        };
      }

      let isOK = this.checkForm();
      if (this.isReady && isOK) {
        this.isReady = false;
        this.$api.post(
          this.$urls.USER.LOGIN,
          params,
          (resp) => {
            this.isReady = true;
            if (resp.data.code === undefined) {
              if (resp.data.data.code === 200) {
                common.logedUserInfo();
                this.username = "";
                this.password = "";
                this.vrifyCode = "";
                let data = resp.data.data;
                if (data["UUID"]) {
                  this.checkLogin();
                }
              } else {
                if (resp.data.data.code === 99998) {
                  this.password = "";
                  this.vrifyCode = "";
                  let data = resp.data.data;
                  if (data["UUID"]) {
                    this.checkLogin();
                  }
                  this.setShowRepwd(true);
                  return;
                }
                this.vrifyCode = "";
                this.getVifyCode();
                this.$message({
                  showClose: true,
                  message: resp.data.data.msg,
                  type: "warning",
                });
              }
            } else {
              let msg = resp.data.msg ? resp.data.msg : resp.data.message;
              this.$message({
                showClose: true,
                message: msg,
                type: "warning",
              });
            }
          },
          (err) => {
            this.isReady = true;
          }
        );
      }
    },
      // 获取验证码
    getVifyCode () {
      this.vrifyCode = ''
      // let randomStr = common.randomRange(16)
      let timestamp = this.getTimestamp(1)
      this.$api.axios({
        url: this.$urls.USER.captcha,
        method: 'get',
        responseType: 'blob',
        params: {
          node: 'login',
          timestamp
        }
      }).then(res => {
        common.blobToDataURI(res.data, str => {
          this.securityCodeSrc = str
        })
        this.timestamp = timestamp
      })
    },
    checkForm() {
      let isOK = true;
      //检验账号
      if (this.username === "") {
        this.$message({
          message: "请输入账号",
          type: "warning",
        });
        isOK = false;
      }
      //校验密码
      if (this.password === "") {
        this.$message({
          message: "请输入账号",
          type: "warning",
        });
        isOK = false;
      }

      if (!this.loginCaptchaId) {
        if (this.vrifyCode === "") {
          this.$message({
            message: "请输入验证码",
            type: "warning",
          });
          isOK = false;
        }
      }
      return isOK;
    },
    loginOut() {
      commonApi.USER.loginOut()
        .then((msg) => {
          this.$message({
            message: msg,
            type: "warning",
          });
          this.$router.push({ path: "/" });
          location.reload();
        })
        .catch((err) => {});
    },
    refresh(hideMessage) {
      this.isRotate = true;
      commonApi.WALLET.refresh()
        .then((data) => {
          this.isRotate = false;
          this.getFirstInfo();
          !hideMessage && this.$message({
            message: "刷新成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.isRotate = false;
        });
    },
    // 易盾代码
    capPop() {
      this.instance.verify();
    },
    getTimestamp(msec) {
      msec = !msec && msec !== 0 ? msec : 1;
      return parseInt(new Date().valueOf() / msec, 10);
    },
    loadScript(src, cb) {
      var head = document.head || document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      cb = cb || function () {};
      script.type = "text/javascript";
      script.src = src;
      if (!("onload" in script)) {
        script.onreadystatechange = function () {
          if (this.readyState !== "complete" && this.readyState !== "loaded")
            return;
          this.onreadystatechange = null;
          cb(script);
        };
      }
      script.onload = function () {
        this.onload = null;
        cb(script);
      };
      head.appendChild(script);
    },
  },
  mounted() {
    this.getVifyCode();

  },
  destroyed() {
    this.IS_LOGIN_FOCUS(false);
  },
};
</script>

<style scoped lang="scss">
.captcha {
  width: 100%;
  // height: 100px;
  position: relative;
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.login-page {
  overflow: hidden;
  .login-wrap {
    margin-top: 25px;
    float: right;
    width: 280px;
    height: 337px;
    background: url("./login_bg.png") no-repeat center top;
    background-size: cover;
    .input-area {
      padding: 0 20px;
      .input-item {
        margin-bottom: 5px;
      }
      .title {
        text-align: center;
        padding: 18px 0 15px;
      }
      .login-out {
        .btn-wrap {
          padding: 5px 0;
          button {
            height: 34px;
            width: 110px;
            border: none;
            outline: none;
          }
          .left {
            background: url("./btn01.1.png");
            background-size: cover;
            margin-right: 15px;
          }
          .right {
            color: #6e3a0f;
            background: url("./btn02.1.png");
            background-size: cover;
          }
        }
        .forgetPassword {
          cursor: pointer;
          margin-top: 5px;
          color: #fff1bb;
        }
      }
      .login-in {
        color: #fff;
        .balance {
          .rotate {
            animation: rotate 0.5s linear infinite;
          }
        }
        p {
          line-height: 26px;
          position: relative;
        }
        .info {
          color: #ff0;
        }
        .inemail {
          margin-left: 10px;
        }
        .mine-nav {
          li {
            display: inline-block;
            line-height: 26px;
            a {
              color: #fff;
              &:before {
                content: "|";
                color: #fff;
                font-size: 12px;
                padding: 0 5px;
              }
            }
          }
          .line {
            a {
              &:before {
                content: none;
              }
            }
          }
        }
        button {
          margin-top: 10px;
          width: 100%;
          background: url("./btn05.png");
          background-size: 100% 100%;
        }
      }
    }
    .notice {
      margin-top: 26px;
      padding-left: 40px;
      padding-right: 10px;
    }
  }
}
.loginOnly {
  .login-wrap {
    height: 239px;
    margin-top: 0;
    // background: url("./login02.png") no-repeat center top;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/base/login/login.vue